// LoadingScreen.js
import React from 'react';
import { Box } from '@mui/material';
import LoadingAnimation from './loadingAnimation';

const LoadingScreen = ({ style, onClick }) => {
  return (
    <Box
      onClick={onClick}
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        width: '100vw',
        height: '100vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        backgroundColor: 'rgba(0, 0, 0, 0.5)', // Semi-transparent background
        overflow: 'hidden', // Prevent scrolling
        zIndex: 120, // Ensure it's on top of everything
        ...style,
      }}
    >
      <Box sx={{ position: 'relative', width: '90px', height: '90px' }}>
        <LoadingAnimation width="100%" height="100%" />
      </Box>
    </Box>
  );
};

export default LoadingScreen;
